<template lang="html">
  <div ref="model" class="model d-flex flex-column justify-content-around" v-if="$route.query.model" style="z-index:999" :style="{ opacity: opacity }">
    <button  @keyup.81="prev" @keyup.68="next" @keyup.90.stop="up" @keyup.83.stop="down" @keyup.space="showHide">
      <img id="model" :src="current" :class='classFormat'></img>
    </button>
  </div>
</template>

<script lang="js">
  export default {
    ssname: 'model',
    props: ['path', 'content', 'format'],
    mounted () {
    },
    data () {
      return {
        currentOffset: 0,
        visible: true,
        opacity: 0.5
      }
    },
    methods: {
      prev () {
        this.currentOffset--
        if (this.currentOffset < 0) {
          this.currentOffset = this.content.length - 1
        }
      },
      next () {
        this.currentOffset++
        if (this.currentOffset >= this.content.length) {
          this.currentOffset = 0
        }
      },
      up () {
        if (this.$refs.model) {
          console.log('UP')
          this.opacity += 0.1
          this.$refs.model.style.opacity = this.opacity
        }
      },
      down () {
        if (this.$refs.model) {
          console.log('DOWN')
          this.opacity -= 0.1
          this.$refs.model.style.opacity = this.opacity
        }
      },
      showHide () {
        console.log('SPACE')
        if (this.$refs.model) {
          if (this.visible) {
            this.$refs.model.style.opacity = 0
            this.visible = false
          } else {
            this.$refs.model.style.opacity = this.opacity
            this.visible = true
          }
        }
      }
    },
    computed: {
      current () {
        return `${this.path}/${this.content[this.currentOffset]}`
      },
      classFormat: function () {
        return {
          '_43': this.format === 43,
          '_169': this.format === 169,
          '_1610': this.format === 1610
        }
      }
    }
}
</script>

<style lang="scss">
  .model {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0px;
    left: 0px;

    #model {
      object-fit: contain;

      &._169 {
        width: 160vh;
        height: 90vh;
      }

      &._1610 {
         width: 160vh;
         height: 100vh;
       }

      &._43 {
        width: 133.33vh;
        height: 100vh;
      }
    }

    button {
      padding: 0px;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/debug/model.vue